// extracted by mini-css-extract-plugin
module.exports = {"singleSliderWrapper":"slider_singleSliderWrapper__zjlCX","sliderContent":"slider_sliderContent__2n2t0","heading":"slider_heading__2bMc8"};